import * as React from "react";
import { io, Socket } from "socket.io-client";

export const SocketContext = React.createContext<Socket | undefined>(undefined);

export interface Receiver {
    id: string;
}

export interface Sender {
    id: string;
    name?: string;
    accessToken?: string;
    role: string;
}

export interface Props {
    host?: string;
}

export interface State {
    socket?: Socket;
}

export class SocketProvider extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        const { host } = this.props;
        this.state = {
            socket: host ? io(host) : undefined,
        };
    }

    componentWillUnmount = () => {
        const { socket } = this.state;
        socket?.close();
    };

    render = () => {
        const { socket } = this.state;
        return (
            <SocketContext.Provider value={socket}>{this.props.children}</SocketContext.Provider>
        );
    };
}
